export const INVOICES_STATUS = {
	PAID: 'paid',
	OVERDUE: 'overdue',
	PARTIALLY_PAID: 'partially_paid',
	CARRIED_OVER: 'Carried Over',
	PENDING: 'pending',
};
